import React from 'react';
import Icon from '../../../components/AppIcon';

const CustomerList = ({ customers, selectedCustomer, onCustomerSelect }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Activo':
        return 'bg-success-100 text-success border-success-200';
      case 'Pendiente':
        return 'bg-warning-100 text-warning border-warning-200';
      case 'Inactivo':
        return 'bg-error-100 text-error border-error-200';
      default:
        return 'bg-secondary-100 text-text-secondary border-secondary-200';
    }
  };

  const getRelationshipIcon = (relationshipStatus) => {
    switch (relationshipStatus) {
      case 'Cliente Premium':
        return 'Crown';
      case 'Cliente Frecuente':
        return 'Star';
      case 'Cliente Nuevo':
        return 'UserPlus';
      default:
        return 'User';
    }
  };

  if (customers.length === 0) {
    return (
      <div className="card">
        <div className="p-8 text-center">
          <Icon name="Search" size={48} className="mx-auto text-text-muted mb-4" />
          <h3 className="text-lg font-heading-semibold text-text-secondary mb-2">
            No se encontraron clientes
          </h3>
          <p className="text-text-muted">
            Ajusta los filtros o términos de búsqueda
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="p-4 border-b border-border">
        <h2 className="text-lg font-heading-semibold text-text-primary">
          Lista de Clientes
        </h2>
        <p className="text-sm text-text-secondary mt-1">
          {customers.length} cliente{customers.length !== 1 ? 's' : ''} encontrado{customers.length !== 1 ? 's' : ''}
        </p>
      </div>

      <div className="max-h-96 overflow-y-auto">
        {customers.map((customer) => (
          <div
            key={customer.id}
            onClick={() => onCustomerSelect(customer)}
            className={`p-4 border-b border-border last:border-b-0 cursor-pointer transition-micro hover:bg-secondary-50 ${
              selectedCustomer?.id === customer.id ? 'bg-primary-50 border-primary-100' : ''
            }`}
          >
            <div className="flex items-start justify-between mb-2">
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-body-semibold text-text-primary truncate">
                  {customer.company}
                </h3>
                <p className="text-xs text-text-secondary truncate">
                  {customer.contactPerson}
                </p>
              </div>
              <div className="ml-2 flex items-center space-x-1">
                <Icon 
                  name={getRelationshipIcon(customer.relationshipStatus)} 
                  size={14} 
                  className={`${customer.relationshipStatus === 'Cliente Premium' ? 'text-warning' : 
                    customer.relationshipStatus === 'Cliente Frecuente' ? 'text-primary' : 'text-text-muted'}`}
                />
              </div>
            </div>

            <div className="flex items-center justify-between mb-2">
              <span className="text-xs text-text-muted flex items-center">
                <Icon name="MapPin" size={12} className="mr-1" />
                {customer.location}
              </span>
              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-body-medium border ${getStatusColor(customer.status)}`}>
                {customer.status}
              </span>
            </div>

            <div className="flex items-center justify-between text-xs text-text-muted">
              <span className="flex items-center">
                <Icon name="Building" size={12} className="mr-1" />
                {customer.industry}
              </span>
              <span className="flex items-center">
                <Icon name="ShoppingCart" size={12} className="mr-1" />
                {customer.totalOrders} pedidos
              </span>
            </div>

            <div className="mt-2 pt-2 border-t border-secondary-100">
              <div className="flex items-center justify-between text-xs">
                <span className="text-text-muted">Ingresos totales:</span>
                <span className="font-body-semibold text-success">{customer.totalRevenue}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerList;